import { RaceWinnerColumnPropsType } from 'src/components/CustomersBar/EventsTab/RacingTab/QuickPickView/RaceWinner/RaceWinnerColumn';
import { AppState } from 'src/AppState/AppState';
import { computed, makeAutoObservable } from 'mobx';
import { EventModel } from 'src_common/common/websocket2/models/EventModel';
import { MarketModel } from 'src_common/common/websocket2/models/MarketModel';
import { CompetitionModel } from 'src_common/common/websocket2/models/CompetitionModel';
import { SelectionModel } from 'src_common/common/websocket2/models/SelectionModel/SelectionModel';

export class RaceWinnerColumnState {
    public constructor(
        private readonly props: RaceWinnerColumnPropsType,
        private readonly appState: AppState
    ) {
        makeAutoObservable(this);
    }

    @computed public get eventInCurrentColumn(): EventModel | null {
        return this.appState.websocketV2.getEvent(this.props.eventId);
    }

    @computed public get marketInCurrentColumn(): MarketModel | null {
        return this.appState.websocketV2.getMarket(this.props.marketId);
    }

    @computed public get currentCompetition(): CompetitionModel | null {
        if (this.eventInCurrentColumn !== null) {
            return this.appState.websocketV2.getCompetitionModel(this.eventInCurrentColumn.competition);
        }
        return null;
    }

    public onClickColumnTitle = (): void => {
        if (this.eventInCurrentColumn !== null) {
            this.props.quickPickState.setSelectedEventIdToURL(this.eventInCurrentColumn.id.toString());
        }
    };

    public onSelect = (): void => {
        const { onHoverEventHandler } = this.props.quickPickState;

        if (this.eventInCurrentColumn !== null) {
            onHoverEventHandler(this.eventInCurrentColumn.id);
        }
    };

    public onHover = (selection: SelectionModel) => {
        const { onHoverSelectionHandler } = this.props.quickPickState;
        const event = this.eventInCurrentColumn;
        if (event !== null) {
            onHoverSelectionHandler(event.id, selection.id);
        }
    };
}
